import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { Ref } from 'vue'
import type { Organization } from '@/types/participant.ts'
import type { OrganizationCourseUpload } from '@/types/course.ts'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function valueUpdater<T>(updaterOrValue: T, ref: Ref) {
  ref.value = typeof updaterOrValue === 'function' ? updaterOrValue(ref.value) : updaterOrValue
}

export function getFlagEmoji(countryCode: string | undefined): string {
  if (!countryCode || countryCode.length !== 2) {
    return '🇺🇳'
  }
  const codeA = 'A'.charCodeAt(0)
  const codeZ = 'Z'.charCodeAt(0)
  const firstChar = countryCode.toUpperCase().charCodeAt(0)
  const secondChar = countryCode.toUpperCase().charCodeAt(1)

  if (firstChar < codeA || firstChar > codeZ || secondChar < codeA || secondChar > codeZ) {
    return '🌍'
  }
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt(0))
  return String.fromCodePoint(...codePoints)
}

export const getOrgId = (
  org: number | Organization | OrganizationCourseUpload | null | undefined,
): number | null => {
  if (typeof org === 'number') {
    return org
  }
  if (org === null || typeof org === 'undefined') {
    return null
  }
  // Check per Organization (ha .id)
  if ('id' in org && typeof org.id === 'number') {
    return org.id
  }
  // Check per IntField/OrganizationCourseUpload (ha .value)
  if ('value' in org && org.value !== null && typeof org.value === 'number') {
    return org.value
  }
  return null
}
